module.exports = __webpack_public_path__ + "assets/images/hospitalized_r.b9943362.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/hospitalized_r.png
// module id = 739
// module chunks = 1